import { createFormAction } from 'redux-form-saga';
import * as productCpsrbCommentFormTypes from './productCpsrbCommentFormTypes';

export const submitProductCpsrbCommentForm = createFormAction(
  productCpsrbCommentFormTypes.SUBMIT_PRODUCT_CPSRB_COMMENT_FORM,
);
